module.exports = __webpack_public_path__ + "images/emoji/shit.d59772ccce323cff1afe.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/shit.png
// module id = /EPO
// module chunks = 13